import {
  GoogleAuthProvider,
  signInWithPopup as fbSignInWithPopup,
  signOut as fbSignOut,
  type Auth,
  type UserCredential,
} from 'firebase/auth';
import type { AuthUser } from './authStore';

const ALLOWED_DOMAIN = 'pontotel.com.br';

interface SignInDeps {
  auth: Auth;
  signInWithPopup?: (auth: Auth, provider: GoogleAuthProvider) => Promise<UserCredential>;
  signOut?: (auth: Auth) => Promise<void>;
  buildProvider?: () => GoogleAuthProvider;
}

export async function signInWithPontotelDomain(deps: SignInDeps): Promise<AuthUser> {
  const buildProvider = deps.buildProvider ?? (() => new GoogleAuthProvider());
  const popup = deps.signInWithPopup ?? fbSignInWithPopup;
  const signOut = deps.signOut ?? fbSignOut;

  const provider = buildProvider();
  provider.setCustomParameters({ hd: ALLOWED_DOMAIN });

  const credential = await popup(deps.auth, provider);
  const user = credential.user;
  const email = user.email ?? '';

  if (!email.toLowerCase().endsWith(`@${ALLOWED_DOMAIN}`)) {
    await signOut(deps.auth);
    throw new Error(
      `Domínio não permitido (${email}). Apenas contas @${ALLOWED_DOMAIN} têm acesso.`,
    );
  }

  return { uid: user.uid, email, displayName: user.displayName };
}
